import { createContext, use, useReducer } from "react";
import { getGaConsentSettings, setGaConsentSettings } from "./api";
import { CookieConsentModal } from "./components";
import type { ActionDispatch, PropsWithChildren } from "react";
import type { GAConsentSettings } from "./types";
import { invariant } from "@/lib/invariant";

const GaConsentContext = createContext<
  [GAConsentSettings | null, ActionDispatch<[action: GaContextReducerAction]>]
>(null!);

export function useGaConsentContext() {
  const context = use(GaConsentContext);
  invariant(
    (context as unknown) !== null,
    "GA Consent Context requested without provider",
  );
  return context;
}

type GaContextReducerAction = {
  verb: "update";
  value: Partial<GAConsentSettings>;
};

function GaContextReducer(
  prevState: GAConsentSettings | null,
  action: GaContextReducerAction,
): GAConsentSettings {
  // protect against accidental wrong action
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (action.verb === "update") {
    const newState = { ...prevState, ...action.value };
    setGaConsentSettings(newState);
    return newState;
  } else throw new Error(`invalid action ${action.verb}`);
}
export function GtagProvider({ children }: PropsWithChildren) {
  const value = useReducer(GaContextReducer, getGaConsentSettings());

  return (
    <GaConsentContext.Provider value={value}>
      <CookieConsentModal />
      {children}
    </GaConsentContext.Provider>
  );
}
